import actions from './actions';

const {
  GET_FEATURES_CATEGORY_BEGIN,
  GET_FEATURES_CATEGORY_SUCCESS,
  GET_FEATURES_CATEGORY_FAILED,
  ADD_FEATURES_CATEGORY_BEGIN,
  ADD_FEATURES_CATEGORY_SUCCESS,
  ADD_FEATURES_CATEGORY_FAILED,
  UPDATE_FEATURES_CATEGORY_BEGIN,
  UPDATE_FEATURES_CATEGORY_SUCCESS,
  UPDATE_FEATURES_CATEGORY_FAILED,
  DELETE_FEATURES_CATEGORY_BEGIN,
  DELETE_FEATURES_CATEGORY_SUCCESS,
  DELETE_FEATURES_CATEGORY_FAILED,
} = actions;

const initState = {
  featuresCategory: [],
  loading: false,
  error: null,
};

const FeaturesCategoryReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_FEATURES_CATEGORY_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_FEATURES_CATEGORY_SUCCESS:
      return {
        ...state,
        featuresCategory: data,
        loading: false,
      };
    case GET_FEATURES_CATEGORY_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_FEATURES_CATEGORY_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_FEATURES_CATEGORY_SUCCESS:
      return {
        ...state,
        featuresCategory: data,
        loading: false,
      };
    case ADD_FEATURES_CATEGORY_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_FEATURES_CATEGORY_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_FEATURES_CATEGORY_SUCCESS:
      return {
        ...state,
        featuresCategory: data,
        loading: false,
      };
    case UPDATE_FEATURES_CATEGORY_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_FEATURES_CATEGORY_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_FEATURES_CATEGORY_SUCCESS:
      return {
        ...state,
        featuresCategory: data,
        loading: false,
      };
    case DELETE_FEATURES_CATEGORY_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default FeaturesCategoryReducer;
